module.exports = __webpack_public_path__ + "img/2-sendi.56cedc04.png";